module.exports = __webpack_public_path__ + "static/media/udemy.bd18d6ff.png";